import { Component } from '@angular/core';
import { CategoryNavigationComponent } from '@spartacus/storefront';

@Component({
  selector: 'cx-category-navigation',
  templateUrl: './category-navigation.component.html',
  styleUrl: './category-navigation.component.scss',
  standalone: false,
})
export class CustomCategoryNavigationComponent extends CategoryNavigationComponent {}
